/** The alert sound files on the server and what was decided about each (backend app/api/sounds.py,
 * docs/alert_sounds.md). A file seen for the first time is a draft; approved ones are in the pickers.
 *
 *   GET  /api/sounds
 *   POST /api/sounds/status   { id, status }
 */

import { getJson } from "@/lib/http";

export type SoundStatus = "draft" | "published";

export interface ServerSound {
  id: string;
  label: string;
  group: string;
  size: number;
  status: SoundStatus;
}

export const soundsApi = {
  list: async (): Promise<ServerSound[]> =>
    (await getJson<{ sounds: ServerSound[] }>("/api/sounds")).sounds,
  setStatus: (id: string, status: SoundStatus): Promise<{ id: string; status: SoundStatus }> =>
    getJson("/api/sounds/status", { method: "POST", body: JSON.stringify({ id, status }) }),
};
